import { Injectable, inject } from '@angular/core';
import { SITE_CONFIG } from './site-config.token';
import { SiteConfig } from './site-config.interface';

@Injectable({ providedIn: 'root' })
export class SiteConfigService {
  private config = inject(SITE_CONFIG);

  get siteId() { return this.config.siteId; }
  get siteType() { return this.config.siteType; }
  get brand() { return this.config.brand; }
  get theme() { return this.config.theme; }
  get contact() { return this.config.contact; }
  get socials() { return this.config.socials; }
  get seo() { return this.config.seo; }
  get nav() { return this.config.nav; }
  get footerLinks() { return this.config.footerLinks; }
  get footerServices() { return this.config.footerServices; }
  get routeSeo() { return this.config.routeSeo; }
  get promotions() { return this.config.promotions; }
  get pages() { return this.config.pages; }

  /** Whether this site is the corporate parent */
  get isCorporate() { return this.config.siteType === 'corporate'; }

  /** Get the full config object */
  getConfig(): SiteConfig { return this.config; }
}
